import { Card, CardContent } from '@material-ui/core';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { downloadAttachment } from '../../../redux/intervention/extranetInterventionActions';
import TableWithoutPagination from '../../Table/TableWithoutPagination';

class InterventionAttachments extends Component {

    constructor(props) {
        super(props);

        this.state = {
            columns: [
                {
                    id: 'name',
                    accessor: a => a.name,
                },
            ]
        }
    }

    downloadAttachment(attachment) {
        this.props.downloadAttachment(attachment, this.props.activeUser);
    }

    getTableTrProps(state, rowInfo) {
        if (rowInfo && rowInfo.row) {
            return {
                onClick: this.downloadAttachment.bind(this, rowInfo.row._original),
                style: {
                    cursor: 'pointer'
                },
            }
        } else {
            return {}
        }
    }

    render() {
        return (
            <Card className="card">
                <CardContent className="row without-side-padding-only-small-screen">
                    <TableWithoutPagination
                        data={this.props.attachments}
                        columns={this.state.columns}
                        getTrProps={this.getTableTrProps.bind(this)}
                    />
                </CardContent>
            </Card>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        attachments: state.extranetIntervention.attachments,
        activeUser: state.activeUser,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        downloadAttachment: (attachment, user) => dispatch(downloadAttachment(attachment, user)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(InterventionAttachments);


